import {
  Select
} from "@chakra-ui/react";

import { useTranslation } from "react-i18next";
import { SECONDARY_COLOR } from "../constants/color";

export default function LanguageCombo() {
  const { i18n } = useTranslation();

  return (
    <Select
      width="42px"
      icon=""
      value={i18n.language}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      border="1px solid"
      borderColor={SECONDARY_COLOR}
      color={SECONDARY_COLOR}
      sx={{
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        paddingInlineEnd: "12px",
        paddingInlineStart: "12px",
      }}
    >
        <option value="id">🇮🇩</option>
        <option value="en">🇺🇸</option>
    </Select>
  );
}